import { SvgIcon, SvgIconProps } from "@mui/material";

export const CurlyBracesIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 18 15" fill="none" {...props}>
			<path
				d="M4.83333 0.833984C4.39131 0.833984 3.96738 1.00958 3.65482 1.32214C3.34226 1.6347 3.16667 2.05862 3.16667 2.50065L3.16667 5.00065C3.16667 5.66369 2.99107 6.29958 2.67851 6.76842C2.36595 7.23726 1.94203 7.50065 1.5 7.50065C1.94203 7.50065 2.36595 7.76404 2.67851 8.23288C2.99107 8.70172 3.16667 9.33761 3.16667 10.0007V12.5007C3.16667 12.9427 3.34226 13.3666 3.65482 13.6792C3.96738 13.9917 4.39131 14.1673 4.83333 14.1673M13.1667 0.833984C13.6087 0.833984 14.0326 1.00958 14.3452 1.32214C14.6577 1.6347 14.8333 2.05862 14.8333 2.50065V5.00065C14.8333 5.66369 15.0089 6.29958 15.3215 6.76842C15.634 7.23726 16.058 7.50065 16.5 7.50065C16.058 7.50065 15.634 7.76404 15.3215 8.23288C15.0089 8.70172 14.8333 9.33761 14.8333 10.0007V12.5007C14.8333 12.9427 14.6577 13.3666 14.3452 13.6792C14.0326 13.9917 13.6087 14.1673 13.1667 14.1673"
				stroke="#FAFAFA"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};
